import { useState, useEffect } from "react";
import { api } from "../api";

export default function Approvazioni() {
  const [lista, setLista]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal]   = useState(null); // { approvazione, esito }
  const [nota, setNota]     = useState("");
  const [saving, setSaving] = useState(false);

  const carica = async () => {
    setLoading(true);
    try { setLista(await api.approvPendenti()); }
    catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { carica(); }, []);

  const decidi = async () => {
    setSaving(true);
    try {
      await api.decidiApprov(modal.approvazione.id, modal.esito, nota);
      setModal(null); setNota(""); carica();
    } catch (e) { alert(e.message); }
    setSaving(false);
  };

  const fmt = (n) => Number(n).toFixed(2).replace(".", ",") + " €";

  return (
    <div className="page">
      <div className="page-header">
        <h1>Approvazioni pendenti</h1>
        {lista.length > 0 && (
          <span className="stato-badge" style={{ background: "#fef3c7", color: "#92400e", fontSize: 13 }}>
            {lista.length} in attesa
          </span>
        )}
      </div>

      {loading && <div className="loading">Caricamento...</div>}

      {!loading && lista.length === 0 && (
        <div className="empty-state">
          <div style={{ fontSize: 48 }}>✅</div>
          <div>Nessuna approvazione pendente</div>
        </div>
      )}

      {!loading && lista.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {lista.map(a => (
            <div key={a.id} className="card" style={{ padding: "20px 24px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}>
                <div>
                  <div style={{ fontFamily: "monospace", fontSize: 15, fontWeight: 800, color: "#0f2850" }}>{a.protocollo}</div>
                  <div style={{ fontSize: 14, fontWeight: 600, marginTop: 4 }}>{a.ragione_sociale}</div>
                  <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>
                    Richiesto da: <strong>{a.richiesto_da_nome}</strong> · {new Date(a.created_at).toLocaleDateString("it-IT")}
                  </div>
                  <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>
                    Sconto: <strong style={{ color: a.sconto_pct > 0 ? "#dc2626" : "inherit" }}>{a.sconto_pct}%</strong>
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: 22, fontWeight: 900, color: "#0f2850" }}>{fmt(a.totale)}</div>
                  <div style={{ display: "flex", gap: 8, marginTop: 10, justifyContent: "flex-end" }}>
                    <button className="btn" style={{ background: "#f0fdf4", color: "#15803d", border: "1px solid #86efac" }}
                      onClick={() => { setModal({ approvazione: a, esito: "approvato" }); setNota(""); }}>
                      ✅ Approva
                    </button>
                    <button className="btn" style={{ background: "#fef2f2", color: "#dc2626", border: "1px solid #fca5a5" }}
                      onClick={() => { setModal({ approvazione: a, esito: "rifiutato" }); setNota(""); }}>
                      ❌ Rifiuta
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modale decisione */}
      {modal && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <div className="modal-card" onClick={e => e.stopPropagation()}>
            <h2 className="card-title">
              {modal.esito === "approvato" ? "✅ Approva preventivo" : "❌ Rifiuta preventivo"}
            </h2>
            <p style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
              {modal.approvazione.protocollo} — {modal.approvazione.ragione_sociale}
            </p>
            <div className="form-group">
              <label className="form-label">Nota {modal.esito === "rifiutato" ? "(obbligatoria)" : "(opzionale)"}</label>
              <textarea className="form-input" rows={3} value={nota} onChange={e => setNota(e.target.value)}
                placeholder={modal.esito === "rifiutato" ? "Motivo del rifiuto..." : "Eventuale commento..."} />
            </div>
            <div className="step-actions">
              <button className="btn btn-ghost" onClick={() => setModal(null)}>Annulla</button>
              <button className="btn btn-primary"
                disabled={saving || (modal.esito === "rifiutato" && !nota.trim())}
                onClick={decidi}>
                {saving ? "Salvataggio..." : "Conferma"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
